import AlertGray from './alert-gray.svg';
import AlertWhite from './alert-white.svg';
import Alert from './alert.svg';
import Arrow from './arrow.svg';
import Calendar from './calendar.svg';
import Close from './close.svg';
import Edit from './edit.svg';
import FileDownload from './file-download.svg';
import FileUpload from './file-upload.svg';
import Header from './header.svg';
import Hint from './hint.svg';
import Line from './line.svg';
import MultiLineInput from './multi-line-input.svg';
import MultipleChoice from './multiple-choice.svg';
import Paragraph from './paragraph.svg';
import Plus from './plus.svg';
import Select from './select.svg';
import Signature from './signature.svg';
import SingleChoice from './single-choice.svg';
import SixDots from './six-dots.svg';
import TextInput from './text-input.svg';
import ThreeColumnsLayout from './three-columns-layout.svg';
import Trash from './trash.svg';
import TwoColumnsLayout from './two-columns-layout.svg';
import Video from './video.svg';

export default {
  Alert,
  AlertWhite,
  AlertGray,
  Arrow,
  Calendar,
  Close,
  Edit,
  FileUpload,
  FileDownload,
  Header,
  Hint,
  Line,
  MultiLineInput,
  MultipleChoice,
  Paragraph,
  Plus,
  Select,
  SingleChoice,
  SixDots,
  TextInput,
  ThreeColumnsLayout,
  Trash,
  TwoColumnsLayout,
  Video,
  Signature,
};
